import { Box, LinearProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { styles } from "../SignupScreen/styles";
import { styles as styles1 } from "./styles";
import * as qs from "qs";
import {
  authEndpoints,
  HTTP,
  PRIVACY_POLICY_LINK,
  TERMS_SERVICE_LINK,
} from "../../utils/constants/httpConstants";
import EventEmitter from "../../utils/emitter/EventEmitter";
import { EMITTER_ERROR } from "../../utils/constants";
import {
  INVALID_PAGE_PATH,
  PLAN_PATH,
} from "../../utils/constants/routes";
import { saveSignupState, loadSignupState } from "../../utils/helpers/signupState";
import Radio from "@mui/material/Radio";
import { Anchor, FullScreenLoader, RightsTag } from "../../components";
import { LOGIN_REACHIQ_LOGO } from "../../utils/constants/assets";

import { useDispatch } from "react-redux";
import { decryptEmail, encryptEmail } from "../../utils/helpers";
import { Strings } from "./strings";
import Image from "../../image/Image";
import Typography from "../../components/Typography/Typography";
import { GREY } from "../../utils/constants/colors";
import { fontWeight } from "../../utils/constants/UI";
import Button from "../../components/Buttons/Button";
import { POST } from "../../Apis/apiWrapper";

const MicrosoftRedirectScreen = () => {
  const classes = styles();
  const classes1 = styles1();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const parsedObject = qs.parse(location.search?.slice(1));
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tenantAccounts, setTenantAccounts] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState("");
  const [token, setToken] = useState("");
  const [navigating, setNavigating] = useState(false);

  useEffect(() => {
    if (!isApiCalled) {
      (async () => {
        try {
          let endPoint = authEndpoints.googleTokenVerify;
          const token = sessionStorage.getItem(Strings.INVITATION_TOKEN);
          const payload = { code: parsedObject?.code, esp: 5 };
          if (token) {
            payload.token = token;
          }
          const encrypedHost = localStorage.getItem(Strings.host);
          if (encrypedHost?.length) {
            const decryptedHost = decryptEmail(encrypedHost || "");
            payload.tenant_url = decryptedHost;
            endPoint = authEndpoints.microsoftLogin;
          }
          localStorage.clear();
          setIsApiCalled(true);

          // api call here vo verify code .
          const response = await POST(endPoint, payload);
          // EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
          if (response?.status === 251) {
            setTenantAccounts(response?.data?.data?.tenants);
            setToken(response?.data?.data?.token);
            setSelectedTenant(response?.data?.data?.tenants?.[0]?._id);
          } else if (response?.status === 252) {
            // New-tenant OAuth signup (2026-07-03): BE seeded a signup draft → enter the SAME paid
            // flow as email signup (Microsoft SSO). No legacy instant-tenant screen.
            const d = response?.data?.data || {};
            const signupState = {
              firstName: d.first_name || "",
              lastName:  d.last_name || "",
              email:     d.owner_email || "",
              draft_id:  d.draft_id,
              oauth:     true,
              provider:  d.provider || "microsoft",
            };
            // Merge — keep preselected_plan/billing captured before the OAuth round-trip.
            saveSignupState({ ...loadSignupState(), ...signupState });
            navigate(PLAN_PATH, { state: signupState });
          } else if (response?.status === 253) {
            const rawData = JSON.parse(JSON.stringify(response?.data?.data));
            delete rawData?.tenant_url;
            const data = JSON.stringify(rawData);
            const encryptedData = encryptEmail(data);
            console.log('URL1', response?.data?.data?.tenant_url?.toString() + "/" + authEndpoints.googleAuthTokenWithoutPrefix?.toString() + encryptedData?.toString());
            console.log('URL2', response?.data?.data?.tenant_url + "/" + authEndpoints.googleAuthTokenWithoutPrefix + encryptedData);
            console.log('URL3', `${response?.data?.data?.tenant_url}/${authEndpoints.googleAuthTokenWithoutPrefix}${encryptedData}`);
            const registrationURL = response?.data?.data?.tenant_url?.toString() + "/" + authEndpoints.googleAuthTokenWithoutPrefix?.toString() + encryptedData?.toString();
            let anchor = document.createElement("a");
            anchor.href = HTTP + registrationURL;
            anchor.click();
          } else {
            const URL = response?.data?.data?.tenant_url;
            let anchor = document.createElement("a");
            anchor.href = HTTP + URL;
            anchor.click();
          }
        } catch (error) {
          EventEmitter.emit(
            EMITTER_ERROR,
            error?.response?.data?.message || error?.data?.message || Strings.ERROR
          );
          navigate(INVALID_PAGE_PATH);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [navigate, parsedObject, isApiCalled, dispatch]);

  const handleMultiTenantContinue = async () => {
    try {
      const payload = {
        tenant_id: selectedTenant,
        token: token,
      };
      setNavigating(true);
      const response = await POST(authEndpoints.loginForTenant, payload);
      const URL = response?.data?.data?.tenant_url;
      let anchor = document.createElement("a");
      anchor.href = HTTP + URL;
      anchor.click();
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR.at, error?.response?.data?.message);
    }
    setNavigating(false);
  };

  return (
    <Box className={classes1.container1}>
      {
        loading || tenantAccounts?.length === 0 ? (
          <FullScreenLoader />
        ) : (
          // This Box is for multiple tenants
          <Box className={classes.container}>
            <Box className={classes.leftContainer}>
              <div className={classes.containLogo}>
                <Image src={LOGIN_REACHIQ_LOGO} className={classes.logo} />
              </div>
              {/* Main auth form here */}
              <Box component="div" className={classes1.headers}>
                <Box className={classes1.containTexts}>
                  {/* <h3 className={classes1.accountsTitle}>Your Accounts</h3> */}
                  <Typography
                    label={Strings.YOUR_ACCOUNTS}
                    color={GREY.PRIMARY}
                    size={"dxs"}
                    fontWeight={fontWeight.SEMIBOLD}
                  />
                  <Typography
                    label={Strings.CHOOSE_ONE_TENANT}
                    color={GREY.TERTIARY}
                    size={"sm"}
                    fontWeight={fontWeight.REGULAR}
                  />
                  {/* <p className={classes.termsPara}>
                    Choose one tenant for Login
                  </p> */}
                </Box>
                {/* <div className={classes.containEmailSignIn}>
             <p className={classes.emailSignIn}>
               <span className={classes.signInSpan}></span>
             </p>
           </div> */}

                <Box>
                  {tenantAccounts?.map((tenant) => {
                    return (
                      <Box
                        className={
                          selectedTenant === tenant?._id
                            ? classes1.borderRed
                            : classes1.borderGrey
                        }
                        onClick={(e) => setSelectedTenant(tenant?._id)}
                      >
                        <Radio
                          className={classes.Radio}
                          checked={selectedTenant === tenant?._id}
                          onChange={(e) => setSelectedTenant(tenant?._id)}
                          value={tenant?._id}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "A" }}
                        />
                        <p className={classes1.tenant_url}>
                          {tenant?.tenant_url}
                        </p>
                      </Box>
                    );
                  })}
                </Box>
                <Box className={classes1.containBtns}>
                  {/* <button className={classes1.cancelBtn}>Cancel</button> */}
                  <Button
                    size={"sm36"}
                    variant={"ghost"}
                    label={Strings.CANCEL}
                  />
                  {navigating ? (
                    <Box className={classes.LINEAR}>
                      <LinearProgress />
                    </Box>
                  ) : (
                    <Button
                      size={"sm36"}
                      variant={"primary"}
                      label={Strings.CONTINUE_WITH_ACC}
                      onClick={handleMultiTenantContinue}
                    />
                    // <button
                    //   className={classes1.continueBtn}
                    //   onClick={handleMultiTenantContinue}
                    // >
                    //   Continue with this account
                    // </button>
                  )}
                </Box>
              </Box>
            </Box>
            {/* <Box className={classes.rightContainer}>
              <h3 className={classes.title}>
                {CONTENT_REGISTER_HEADING?.toUpperCase()}
              </h3>
              <h3 className={classes.title}>
                {CONTENT_REGISTER_HEADING2?.toUpperCase()}
              </h3>

              <p className={classes.para}>{CONTENT_REGISTER_SUBHEADING} </p> */}
            {/* <Box className={classes.iconsContainer}>
                <div className={classes.eachIconContainer}>
                  <ImageIcon image={LOGIN_CROSS_ICON} />
                  <p className={classes.iconPara}>{CONTENT_REGISTER_POINT1}</p>
                </div>
                <div className={classes.eachIconContainer}>
                  <ImageIcon image={LOGIN_CROSS_ICON} />
                  <p className={classes.iconPara}>{CONTENT_REGISTER_POINT2}</p>
                </div>
              </Box> */}
            {/* <Box className={classes.containAnalyticsImage}>
                <Image
                  src={LOGIN_ANALYTICS_IMAGE}
                  alt=""
                  className={classes.analyticsImage}
                />
              </Box>
            </Box> */}
          </Box>
        )
        // This is for multiple tenants
      }
      {/* Main auth form here */}
      <div className={classes.containPolicy}>
        <RightsTag className={classes.termsPara} />
        {/* Privacy and Terms. */}
        <Anchor
          href={PRIVACY_POLICY_LINK}
          className={classes.privacyLink}
          target="_blank"
        >
          <Typography
            size={"xs"}
            color={GREY.SECONDARY}
            fontWeight={fontWeight.SEMIBOLD}
            label={Strings.PRIVACY}
          />{" "}
        </Anchor>
        <div className={classes.TypoHead}>
          <Typography
            size={"xs"}
            color={GREY.TERTIARY}
            fontWeight={fontWeight.REGULAR}
            label={Strings.AND}
          />{" "}
        </div>
        <Anchor
          href={TERMS_SERVICE_LINK}
          className={classes.privacyLink}
          target="_blank"
        >
          <Typography
            size={"xs"}
            color={GREY.SECONDARY}
            fontWeight={fontWeight.SEMIBOLD}
            label={Strings.TERMS}
          />{" "}
        </Anchor>
      </div>
    </Box>
  );
};

export default MicrosoftRedirectScreen;
